export default "__VITE_ASSET__B4ej8nFs__"